export default __webpack_public_path__ + "static/media/btn_ws_advanced.91a7dcb1.jpg";